/**
 * Blinking pipe shown at the end of streamed AI text (authentic token stream).
 */
import React from 'react';

export function StreamCaret({ className = '' }: { className?: string }) {
  return (
    <span
      aria-hidden
      className={`ml-0.5 inline font-mono text-[15px] font-normal leading-none text-[var(--ds-brand)] animate-[blink_0.9s_step-end_infinite] ${className}`}
    >
      |
    </span>
  );
}

export default StreamCaret;
